import * as actionTypes from '../actions/actions';

const initialState = {
    username: null,
    email: null,
    avatarUrl: null,
    isAuthenticated: false
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_USER_DATA:
            return {
                ...state,
                username: action.userData.username,
                email: action.userData.email,
                avatarUrl: action.userData.avatarUrl,
                isAuthenticated: true
            }
        case actionTypes.CLEAR_USER_DATA:
            return {
                ...initialState
            }
        case actionTypes.UPDATE_AVATAR_URL:
            return {
                ...state,
                avatarUrl: action.avatarUrl
            }
        default:
            return state
    }
};

export default userReducer;